<script lang="ts" setup>
// Packages

const props = defineProps({
  startPage: { type: Number, required: true, default: 0 },
  totalPages: { type: Number, required: true, default: 0 },
  maxVisibleButtons: { type: Number, required: false, default: 4 },
  currentPage: { type: Number, required: false, default: 1 },
});

const page = ref(1);
const allowUse = ref(false);
const startButtons = ref(1);
const startPageIndex = ref(1);

const buttons = ref<Array<{ name: number; isDisabled: boolean; }>>([]);

function pages() {
  const range = [];

  startPageIndex.value = props.totalPages > 5 ? props.startPage - 1 || 1 : 1;
  startButtons.value = Math.min(startPageIndex.value + (props.maxVisibleButtons - 1), props.totalPages);

  // Keep alwayes five visible buttons
  if ((props.totalPages - startPageIndex.value) < props.maxVisibleButtons && props.totalPages >= 5) {
    startPageIndex.value -= props.maxVisibleButtons - (props.totalPages - (startPageIndex.value - 1));
  }

  for (let i = startPageIndex.value; i <= startButtons.value; i += 1) {
    range.push({
      name: i,
      isDisabled: i === props.currentPage,
    });
  }

  buttons.value = range;
}

function onClickPage(newPage: number) {
  page.value = newPage;
}

watch([props], pages, { deep: true })
onMounted(pages)

</script>
<template>
  <nav class="block my-8">
    <ul v-if="totalPages > 1" class="flex w-full gap-2 list-none pt-2 pb-4">
      <!-- First -->
      <li
        v-if="startPageIndex > 1 && totalPages > 5"
        :class="{selected: currentPage === 1}"
        class="flex items-center rounded-full justify-center px-4 h-10 w-10 leading-tight hover:bg-gray-100 border border-gray-400"
      >
          <nuxt-link to="/blog?page=1">
            <span class="">
              1
            </span>
        </nuxt-link>
        <a href="#" class="flex items-center rounded-full justify-center px-4 h-10 w-10 leading-tight  hover:bg-gray-100 border border-gray-400">1</a>
        <span class="nv-px-1">..</span>
      </li>
      <li
        v-for="page in buttons"
        :key="page.name"
        :class="{selected: currentPage === page.name}"
        class="nv-mr-1"
      >
        <a
          :href="`/blog?page=${page.name}`"
          class="flex items-center rounded-full justify-center px-4 h-10 w-10 leading-tight  hover:bg-gray-100 border border-gray-400"
        >
          {{ page.name }}
        </a>
      </li>
  
      <!-- Last -->
      <li
        v-if="(currentPage + 1) < totalPages && totalPages > 5"
        :class="{selected: currentPage === totalPages}"
        class="mr-1 flex items-end"
      >
        <span class="px-2">..</span>
        <a
          href="#"
          class="flex items-center rounded-full justify-center px-4 h-10 w-10 leading-tight  hover:bg-gray-100 border border-gray-400"
        >
          {{ totalPages }}
        </a>
      </li>
    </ul>
  </nav>
</template>
<style lang="scss" scoped>
  ul {
    list-style: none;

    li {
      &.selected {
        a {
          background-color: var(--theme);
          border-color: var(--theme);
          color: #fff;

          &:hover {
            background-color: var(--theme);
            opacity: 0.8;
          }
        }
      }

      &:hover {
        a {
          background-color: rgba(var(--theme-rgb), 0.2);
        }
      }
    }
  }
</style>
